import axios from 'axios';
import router from '@/router';
import {
    MessageBox
} from 'element-ui';

const service = axios.create({
    baseURL: process.env.BASE_DEV_API, // 'http://10.72.1.101:8081', // api base_url
    timeout: 3 * 60 * 1000 // request timeout
});
let token = null;

service.interceptors.request.use(
    config => {
        if (Date.now() - sessionStorage.getItem('time') > 1 * 60 * 60 * 1000) {
            sessionStorage.clear();
            router.push({
                name: 'login'
            });
        } else {
            sessionStorage.setItem('time', Date.now()); 
        }
        if (token === null) {
            token = sessionStorage.getItem('token');
        }
        config.action === 'file' ?
            config.responseType = 'arraybuffer' :
            config.responseType = '';
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['Auth-Type'] = 'bypass';
        token = null;
        return config;
    },

    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        console.log(response);
        return response;
    },
    error => {
        // return error.response;
        if (error.response.status === 401) {
            sessionStorage.clear();
            return MessageBox.alert(
                'Session timeout. Please log-in again.',
                'Time out', {
                    showClose: false,
                    confirmButtonText: 'Confirm',
                    callback: action => {
                        router.push({
                            name: 'login'
                        });
                    }
                }
            );
        }
        return error.response;
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js